<template>
  <p class="my-7 text-h6">{{ 'sentence.confirmation'|globalTranslate([getDateFormated, getNumberOfDays()]) }}</p>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "DateAndQtyDisplay",
  computed: {
    ...mapGetters({
      getNumberOfDays: "cart/getNumberOfDays",
      getDateFormated: "cart/getDateFormated"
    })
  }
}
</script>

<style scoped>

</style>
